let _ = t => t,
  _t;
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import UIFlex from 'UIComponents/layout/UIFlex';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import styled from 'styled-components';
import ProductIcon from '../../common/ProductIcon';
import { CompactTitle, FlushedTitle } from '../SharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFlex = styled(UIFlex).withConfig({
  displayName: "PlanPickerHeader__StyledFlex",
  componentId: "sc-1md3azx-0"
})(["", ""], breakpoint.phone(_t || (_t = _`
    flex-direction: column;
    align-items: start;
  `)));
const PlanPickerHeader = ({
  productLine,
  compact,
  isNew = false,
  id
}) => {
  return compact ? /*#__PURE__*/_jsx(CompactTitle, {
    className: "m-bottom-8",
    "aria-level": 3,
    id: id,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `planBuilder.plansHeader.${productLine}.compactTitle`
    })
  }) : /*#__PURE__*/_jsx(StyledFlex, {
    align: "end",
    className: "m-bottom-3",
    id: id,
    children: /*#__PURE__*/_jsxs("div", {
      className: "align-center",
      children: [productLine !== 'crmSuite' && /*#__PURE__*/_jsx(ProductIcon, {
        className: "display-inline m-bottom-1 m-right-2",
        productLine: productLine,
        width: 24
      }), /*#__PURE__*/_jsx(FlushedTitle, {
        "aria-level": 3,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `planBuilder.plansHeader.${productLine}.largeTitle`
        })
      }), isNew && /*#__PURE__*/_jsx(UIBadge, {
        use: "new",
        className: "m-left-3",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.new"
        })
      })]
    })
  });
};
export default PlanPickerHeader;